import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { consultasStockApi } from '../../api/consultasStock'
import { colors, font, sx } from '../../design/tokens'
import { RespuestaDeposito } from '../../components/StockDeposito'
import { fmtFechaHora } from '../../utils/fecha'
import { Buscador, Card, Cargando, ErrorMsg, Miniatura, Seccion, TabsSegmento, Titulo, Vacio } from './comunes'
import MovilStockBajo from './MovilStockBajo'

// Depósito, dos modalidades (Martin, 23 oct 2026): responder las consultas de
// Ventas y avisar stock bajo (código de barras o SKU). La solapa queda en la URL.
export default function MovilConsultasStock() {
  const [params, setParams] = useSearchParams()
  const modo = params.get('modo') === 'stock-bajo' ? 'stock-bajo' : 'consultas'

  return (
    <div>
      <Titulo>Consultas de stock</Titulo>
      <TabsSegmento
        options={[{ k: 'consultas', label: 'Consultas de Ventas' }, { k: 'stock-bajo', label: '📉 Avisar stock bajo' }]}
        value={modo}
        onChange={(k) => setParams(k === 'stock-bajo' ? { modo: k } : {}, { replace: true })}
      />
      {modo === 'stock-bajo' ? <MovilStockBajo /> : <ConsultasPendientes />}
    </div>
  )
}

// Lo que falta responder, un renglón por producto, el que vence primero
// arriba (Martin, 21 oct 2026). Es la entrada sin el link de Telegram.
function ConsultasPendientes() {
  const navigate = useNavigate()
  const [items, setItems] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    consultasStockApi.pendientesDeposito()
      .then(({ data }) => setItems(data.items))
      .catch(() => setError('No se pudieron cargar las consultas pendientes'))
  }, [])

  return (
    <div>
      {error && <ErrorMsg>{error}</ErrorMsg>}
      {!items && !error && <Cargando />}
      {items && items.length === 0 && <Vacio>No hay consultas pendientes.</Vacio>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {(items || []).map((it) => (
          <Card key={it.id} onClick={() => navigate(`/m/consultas-stock/${it.consulta_id}`)}>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <Miniatura codigo={it.codigo_alfa} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontFamily: font.sans, fontWeight: 600, fontSize: 15, lineHeight: 1.25, color: colors.text }}>{it.descripcion}</span>
                {it.verificar_sin_stock && <VerificarSinStock />}
                <span style={{ display: 'block', fontSize: 12.5, color: colors.textSec, marginTop: 2 }}>
                  {it.vendedor}{it.suscriptos_pendientes > 0 ? ` + ${it.suscriptos_pendientes}` : ''}
                </span>
                <div style={{ marginTop: 4 }}><VenceChip vence={it.vence_at} /></div>
              </div>
              <div style={{ textAlign: 'center', flexShrink: 0 }}>
                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', color: colors.textSec }}>PIDE</div>
                <div style={{ ...sx.mono, fontSize: 24, fontWeight: 800, color: colors.text }}>{it.cantidad ?? '—'}</div>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <ConsultasPasadas />
    </div>
  )
}

// Lo ya cerrado (respondido, vencido o cancelado), lo más nuevo arriba, con
// buscador por producto, SKU, vendedor o NV (Martin, 24 oct 2026).
const ABIERTAS = ['pendiente', 'respondida_parcial']
function ConsultasPasadas() {
  const navigate = useNavigate()
  const [consultas, setConsultas] = useState(null)
  const [q, setQ] = useState('')
  const [cuantas, setCuantas] = useState(20)

  useEffect(() => {
    consultasStockApi.listar({ estado: 'todas' })
      .then(({ data }) => setConsultas(data.consultas.filter((c) => !ABIERTAS.includes(c.estado))))
      .catch(() => setConsultas([]))
  }, [])

  const t = q.trim().toLowerCase()
  const filtradas = (consultas || []).filter((c) => !t || [c.vendedor, c.nv_numero, String(c.id), ...c.items.flatMap((it) => [it.descripcion, it.codigo_alfa])]
    .some((v) => (v || '').toLowerCase().includes(t)))

  return (
    <Seccion titulo="Consultas pasadas" style={{ marginTop: 18 }}>
      <Buscador value={q} onChange={setQ} placeholder="Buscar producto, SKU, vendedor o NV" />
      {!consultas && <Cargando />}
      {consultas && filtradas.length === 0 && <Vacio>{t ? 'Sin resultados' : 'Todavía no hay consultas cerradas.'}</Vacio>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 10 }}>
        {filtradas.slice(0, cuantas).map((c) => (
          <Card key={c.id} onClick={() => navigate(`/m/consultas-stock/${c.id}`)}>
            <div style={{ fontSize: 12.5, color: colors.textSec, fontFamily: font.sans, marginBottom: 6 }}>
              Nº {c.id} · {fmtFechaHora(c.created_at)} · {c.vendedor}{c.nv_numero ? ` · ${c.nv_numero}` : ''}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {c.items.map((it) => (
                <div key={it.id} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <span style={{ display: 'block', fontFamily: font.sans, fontWeight: 600, fontSize: 14, lineHeight: 1.25, color: colors.text }}>{it.descripcion}</span>
                    <span style={{ display: 'block', fontSize: 12, color: colors.textMeta, ...sx.mono }}>{it.codigo_alfa}{it.cantidad !== null ? ` · pide ${it.cantidad}` : ''}</span>
                  </div>
                  <div style={{ flexShrink: 0, maxWidth: '48%' }}><RespuestaDeposito item={it} /></div>
                </div>
              ))}
            </div>
          </Card>
        ))}
      </div>
      {filtradas.length > cuantas && (
        <button onClick={() => setCuantas((n) => n + 20)} style={{ ...sx.btnSecondary, width: '100%', marginTop: 10, minHeight: 44 }}>Ver más</button>
      )}
    </Seccion>
  )
}

export function VenceChip({ vence }) {
  if (!vence) return null
  const horas = Math.max(0, Math.round((new Date(vence) - new Date()) / 36e5))
  const urgente = horas <= 4
  return (
    <span style={{
      ...sx.badge, alignSelf: 'flex-start', width: 'fit-content',
      background: urgente ? colors.errBg : colors.bgSoft, color: urgente ? colors.err : colors.textSec,
    }}>
      {horas < 1 ? 'vence en menos de 1 h' : `vence en ${horas} h`}
    </span>
  )
}

/** #124: el vendedor pidió consultar igual un producto que figura sin stock en LGR. */
export function VerificarSinStock() {
  return (
    <span style={{ alignSelf: 'flex-start', display: 'inline-block', marginTop: 4, padding: '2px 8px', borderRadius: 999, fontSize: 12, fontWeight: 700, background: colors.warnBg, color: colors.warn }}>
      ⚠️ Figura sin stock en LGR — verificar estante
    </span>
  )
}
